import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import { Dispatch } from 'redux';
import LabelBox from './label-box';
import { InfoLabel } from '@webapp/controllers/label/info-label';
import FormContainer from '@components/layout/form-container';
import Button from '@components/actions/button';
import AppState from '@webapp/store/state';
import {
  DeleteRecordLabel,
  ListRecordLabelArtists,
} from '../../../store/record-labels/action-creators';
import { RecordLabel } from '@common/types/record-label/record-label';
import { LIST_RECORD_LABEL_ARTIST } from '@webapp/store/record-labels/actions';
import { RecordLabelRelation } from '@services/record-labels/types/record-label-relation';
interface LabelDeletePageProps {
  cancelDelete: () => CallHistoryMethodAction;
  confirmDelete: () => CallHistoryMethodAction;
  listRecordLabelArtists: (labelId: string) => ListRecordLabelArtists;
  removeRecordLabel: (labelId: string) => DeleteRecordLabel;
  className?: string;
  labelId: string;
  label: RecordLabel;
  userLabels: RecordLabel[];
  artistLabels: Object;
  isLoadingList: boolean;
}
interface StateProps {
  labelId?: string;
  artistLabels: Object;
  userLabels: RecordLabel[];
  isLoadingList: boolean;
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    listRecordLabelArtists: (labelId: string) =>
      dispatch(new ListRecordLabelArtists(labelId)),
    removeRecordLabel: (labelId: string) =>
      dispatch(new DeleteRecordLabel(labelId)),
    cancelDelete: () => dispatch(push(`/label`)),
    confirmDelete: () => dispatch(push(`/label/delete/success`)),
  };
};

const mapStateToProps = (state: AppState, props: any): StateProps => {
  const { labelId } = props.match?.params;

  return {
    labelId: labelId,
    userLabels: state.recordLabels.list,
    artistLabels: state.recordLabels.artists[labelId],
    isLoadingList: !!state.ui.loading[LIST_RECORD_LABEL_ARTIST],
  };
};

const LabelDeletePage: React.FC<LabelDeletePageProps> = (props) => {
  const { cancelDelete, listRecordLabelArtists, artistLabels, labelId } = props;
  React.useEffect(() => {
    listRecordLabelArtists(labelId);
  }, [listRecordLabelArtists, labelId]);
  const [artistsArray, setArtistsArray] = React.useState<any>([]);
  React.useEffect(() => {
    setArtistsArray(artistLabels);
  }, [artistLabels]);
  const getReleasesSum = () => {
    return artistsArray?.reduce(
      (acc: number, b: RecordLabelRelation) => acc + (b.artistReleases || 0),
      0
    );
  };
  const getName = () => {
    return (
      props.userLabels.filter((val) => val.id === labelId)[0]?.name ||
      'Label Name'
    );
  };
  return (
    <MotionOpacity className={props.className}>
      <FormContainer>
        <Typography
          weight="400"
          color={'#000000'}
          type="title"
          customSize="40px"
          className="mt-20"
        >
          {getName()}
        </Typography>
        <Typography
          weight="400"
          type="title"
          opacity=".5"
          customSize="14px"
          className="mt-20 mb-20"
        >
          <Translate
            id="LABEL.DELETE.LABEL.SUBHEADING"
            data={{
              ARTISTSCOUNT: artistsArray?.length,
              RELEASESCOUNT: getReleasesSum(),
              LABELNAME: getName(),
            }}
          />
        </Typography>
        {artistsArray?.map((label: any) => (
          <LabelBox
            key={label.id}
            label={label}
            isExternal={label.ownerId === 'EXTERNAL'}
          />
        ))}
        <InfoLabel labelName={getName()} />
        <FlexRow>
          <StyledButton
            buttonType="primary"
            onClick={() => {
              cancelDelete();
            }}
          >
            <Translate id="ONBOARDING.DOWNGRADE.BTN.CANCEL" />
          </StyledButton>

          <StyledButton
            buttonType="secondary"
            onClick={() => {
              props.removeRecordLabel(props.labelId);
            }}
          >
            <Translate id="USER_PROFILE.DEACTIVATE.LIST.TITLE" />
          </StyledButton>
        </FlexRow>
      </FormContainer>
    </MotionOpacity>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(LabelDeletePage)`
  .box {
    margin-bottom: 20px;
    @media ${({ theme }) => theme.device.tablet} {
      margin-bottom: 30px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .loading-animation > div {
    margin: auto;
  }
`);

const StyledButton = styled(Button)`
  @media ${({ theme }) => theme.device.tablet} {
    max-width: 146px;
  }
`;
const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
